<section class="calendar-header desktop bg-corporate flex items-center justify-between h-16 px-6 shadow-lg">
  <div class="logo flex items-center gap-3 cursor-pointer" (click)="clickGoMain($event)">
    <img class="logo-image h-10 w-auto" src="assets/custom/1cal-solucionait/media/iconos/icono/logo.svg" />
    <span class="title-logo text-white font-bold text-xl">1Cal</span>
  </div>

  <h1 class="title text-white font-semibold text-xl truncate flex-1 text-center px-4">{{name}}</h1>

  <div class="header-actions flex items-center gap-3">
    <div class="header-icon-btn active" (click)="clickGoCalendar($event)">
      <lucide-icon name="calendar" [size]="24"></lucide-icon>
      <span class="ctx-tooltip">Calendario</span>
    </div>

    <div *ngIf="role=='super' || role=='admin' || role=='workPlace'"
         class="header-icon-btn"
         (click)="clickGoToSchedules($event)">
      <lucide-icon name="clock" [size]="24"></lucide-icon>
      <span class="ctx-tooltip">Horarios</span>
    </div>

    <div *ngIf="role=='super' || role=='admin' || role=='workPlace'"
         class="header-icon-btn"
         (click)="clickGoToOperators($event)">
      <lucide-icon name="users" [size]="24"></lucide-icon>
      <span class="ctx-tooltip">Operarios</span>
    </div>

    <div class="header-icon-btn" (click)="clickGoMain($event)">
      <lucide-icon name="building-2" [size]="24"></lucide-icon>
      <span class="ctx-tooltip">Centros</span>
    </div>

    <div class="header-icon-btn" (click)="clickExit($event)">
      <lucide-icon name="log-out" [size]="24"></lucide-icon>
      <span class="ctx-tooltip">Salir</span>
    </div>
  </div>
</section>

<section class="calendar-header mobile">
  <div class="w-full flex flex-row items-center justify-between h-16 px-4 shadow-lg">
    <h1 class="title text-white font-semibold text-base truncate text-left flex-1 mr-3">{{name}}</h1>

    <div class="header-icon-btn shrink-0" (click)="mobileMenuOpen = true">
      <lucide-icon name="menu" [size]="24"></lucide-icon>
    </div>
  </div>

  <div id="backdrop" class="backdrop" *ngIf="mobileMenuOpen" (click)="mobileMenuOpen = false"></div>
  <div id="sideNavigation" class="aside mobile" [ngClass]="mobileMenuOpen ? 'menu-open' : 'menu-closed'">
    <app-aside-gral-menu-mobile [name]='name' [calendars]='calendars' (closeMenu)="mobileMenuOpen = false"></app-aside-gral-menu-mobile>
  </div>
</section>

<div class="relative flex flex-row box-border w-full calendar-page-bg overflow-hidden" style="height: calc(100vh - 64px); padding: 8px;">
  <div id="mobileBackdrop" class="backdrop z-[1290] sm:hidden" *ngIf="mobileCalendarOpen" (click)="mobileCalendarOpen = false"></div>
  <button class="sidebar-toggle absolute bottom-3 z-50 w-7 h-7 items-center justify-center bg-corporate border-none rounded-full shadow-md text-white cursor-pointer transition-all duration-200 hover:scale-110 hidden sm:flex" style="left: 264px" (click)="toggleSidebar()" type="button">
    <lucide-icon [name]="collapse ? 'chevron-right' : 'chevron-left'" [size]="18"></lucide-icon>
  </button>
  <div class="fixed inset-y-0 left-0 z-[1300] w-full max-w-none sm:relative sm:z-auto sm:w-[270px] bg-white shadow-2xl overflow-hidden shrink-0 transition-transform duration-300 sm:transition-all sm:duration-200 rounded-none sm:rounded-xl md-lg-mobile-desktop"
       [class.-translate-x-full]="!mobileCalendarOpen"
       [class.translate-x-0]="mobileCalendarOpen"
       [class.sm:translate-x-0]="true"
       id="divCalendarPicker" (click)="closeMenu()">
    <div class="sidebar-content-wrapper flex flex-col bg-gradient-to-b from-white to-[#f8fbff] overflow-y-auto p-3 w-[270px] sm:w-full h-full shrink-0 box-border opacity-100 visible transition-opacity duration-150 sm:opacity-100 sm:visible"
         [class.collapsed]="collapse && !mobileCalendarOpen">
      <div class="flex items-center justify-between mb-2 sm:hidden">
        <h3 class="text-base font-medium text-corporate-3 m-0">Filtros</h3>
        <button type="button" (click)="mobileCalendarOpen = false; $event.stopPropagation()" class="w-8 h-8 inline-flex items-center justify-center rounded-full text-[#5a6b7a] bg-transparent border-none cursor-pointer transition-colors hover:bg-[#f0f4f8] hover:text-corporate">
          <lucide-icon name="x" [size]="20"></lucide-icon>
        </button>
      </div>
      <app-calendar-picker
        (dateSelected)="clickDateSelected($event)"
        (changeDate)="ChangeDate($event)"
        [dateFullCalendar]="this.dateDefault"
        id="calendarPicker"></app-calendar-picker>

      <div class="mt-3 pt-3 border-t border-[#e8edf3]">
        <h3 class="text-xs font-medium text-corporate-3 mb-2 tracking-wide uppercase">Operarios</h3>
        <div *ngIf="loadingResources" class="flex flex-col gap-1 py-1" aria-hidden="true">
          <div *ngFor="let s of [0,1,2,3,4]" class="flex items-center gap-2.5 px-0 py-1.5">
            <span class="skeleton-bone w-4 h-4 rounded-full ml-1"></span>
            <span class="skeleton-bone h-3 rounded-full" [ngClass]="s % 2 === 0 ? 'w-24' : 'w-16'"></span>
          </div>
        </div>
        <div *ngIf="!loadingResources && resources && resources.length > 0" class="flex flex-col gap-1 overflow-y-auto">
          <label *ngFor="let resource of resources" class="flex items-center cursor-pointer rounded-lg transition-colors hover:bg-[#f0f4f8] px-0 py-1.5 gap-2.5" (click)="toggleResourceFilter(resource.id)">
            <span class="w-4 h-4 shrink-0 rounded-full border-2 transition-all duration-200 ml-1"
                  [ngClass]="isResourceVisible(resource.id) ? 'border-transparent' : 'border-[#d4dde6] bg-white'"
                  [style.background-color]="isResourceVisible(resource.id) ? resource.eventColor : 'transparent'">
            </span>
            <span class="text-[13px] text-corporate-3 truncate">{{resource.title}}</span>
          </label>
        </div>
        <div *ngIf="!loadingResources && (!resources || resources.length === 0)" class="text-[13px] text-[#8a97a5] italic px-1 py-2">
          Sin operarios disponibles
        </div>
      </div>
    </div>
  </div>

  <div id="contentCalendarWrap" class="flex-grow basis-0 bg-gradient-to-b from-white to-[#f8fbff] rounded-xl shadow-sm overflow-hidden min-h-0 min-w-0 flex flex-col ml-0 sm:ml-2 transition-[margin-left] duration-200">
    <div class="shrink-0 p-3">
      <div class="hidden sm:flex sm:items-center sm:justify-between gap-2">
        <h2 class="text-base font-medium text-corporate-3 m-0 capitalize truncate">{{currentViewTitle}}</h2>
        <div class="flex flex-wrap items-center gap-2">
          <button type="button" (click)="goToToday()" [ngClass]="isTodayView ? 'bg-corporate text-white' : 'bg-[#eef3f9] text-corporate-3'" class="text-xs font-medium rounded-lg transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate px-3 h-8 inline-flex items-center">Hoy</button>
          <div class="flex gap-0.5">
            <button type="button" (click)="getEventsBefore($event)" class="flex items-center justify-center rounded-lg bg-[#eef3f9] text-corporate-3 transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate w-8 h-8">
              <lucide-icon name="chevron-left" [size]="16"></lucide-icon>
            </button>
            <button type="button" (click)="getEventsAfter($event)" class="flex items-center justify-center rounded-lg bg-[#eef3f9] text-corporate-3 transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate w-8 h-8">
              <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
            </button>
          </div>
          <button type="button" (click)="goToSearchEvents()" class="flex items-center justify-center rounded-lg bg-[#eef3f9] text-corporate-3 transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate w-8 h-8">
            <lucide-icon name="search" [size]="16"></lucide-icon>
          </button>
          <div class="flex rounded-lg bg-[#f0f4f8] gap-0.5 p-0">
            <button type="button" (click)="changeToView('resourceTimeGridDay')" [ngClass]="viewType==='day' ? 'bg-corporate text-white' : 'bg-transparent text-[#5a6b7a]'" class="text-xs font-medium rounded-md transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate-3 px-3 h-8 inline-flex items-center">Planificador</button>
            <button type="button" (click)="changeToView('timeGridWeek')" [ngClass]="viewType==='week' ? 'bg-corporate text-white' : 'bg-transparent text-[#5a6b7a]'" class="text-xs font-medium rounded-md transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate-3 px-3 h-8 inline-flex items-center">Semana</button>
            <button type="button" (click)="changeToView('dayGridMonth')" [ngClass]="viewType==='month' ? 'bg-corporate text-white' : 'bg-transparent text-[#5a6b7a]'" class="text-xs font-medium rounded-md transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate-3 px-3 h-8 inline-flex items-center">Mes</button>
          </div>
        </div>
      </div>

      <div class="sm:hidden flex flex-col gap-2">
        <div class="flex flex-row items-center justify-between gap-2">
          <h2 class="text-sm font-medium text-corporate-3 m-0 capitalize truncate flex-1">{{mobileTitle}}</h2>
          <div class="flex items-center gap-1.5 shrink-0">
            <button type="button" (click)="toggleMobileCalendar()" class="w-8 h-8 inline-flex items-center justify-center rounded-lg bg-[#eef3f9] text-corporate-3 transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate">
              <lucide-icon name="calendar-days" [size]="16"></lucide-icon>
            </button>
            <button type="button" (click)="goToToday()" [ngClass]="isTodayView ? 'bg-corporate text-white' : 'bg-[#eef3f9] text-corporate-3'" class="text-xs font-medium rounded-lg transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate px-3 h-8 inline-flex items-center">Hoy</button>
            <button type="button" (click)="getEventsBefore($event)" class="flex items-center justify-center rounded-lg bg-[#eef3f9] text-corporate-3 transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate w-8 h-8">
              <lucide-icon name="chevron-left" [size]="16"></lucide-icon>
            </button>
            <button type="button" (click)="getEventsAfter($event)" class="flex items-center justify-center rounded-lg bg-[#eef3f9] text-corporate-3 transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate w-8 h-8">
              <lucide-icon name="chevron-right" [size]="16"></lucide-icon>
            </button>
            <button type="button" (click)="goToSearchEvents()" class="flex items-center justify-center rounded-lg bg-[#eef3f9] text-corporate-3 transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate w-8 h-8">
              <lucide-icon name="search" [size]="16"></lucide-icon>
            </button>
          </div>
        </div>
        <div class="grid grid-cols-3 gap-0.5 rounded-lg bg-[#f0f4f8] p-0.5">
          <button type="button" (click)="changeToView('resourceTimeGridDay')" [ngClass]="viewType==='day' ? 'bg-corporate text-white' : 'bg-transparent text-[#5a6b7a]'" class="text-xs font-medium rounded-md transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate-3 h-8 inline-flex items-center justify-center border-none cursor-pointer">Planificador</button>
          <button type="button" (click)="changeToView('timeGridWeek')" [ngClass]="viewType==='week' ? 'bg-corporate text-white' : 'bg-transparent text-[#5a6b7a]'" class="text-xs font-medium rounded-md transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate-3 h-8 inline-flex items-center justify-center border-none cursor-pointer">Semana</button>
          <button type="button" (click)="changeToView('dayGridMonth')" [ngClass]="viewType==='month' ? 'bg-corporate text-white' : 'bg-transparent text-[#5a6b7a]'" class="text-xs font-medium rounded-md transition-colors duration-200 hover:bg-[#e1eaf4] hover:text-corporate-3 h-8 inline-flex items-center justify-center border-none cursor-pointer">Mes</button>
        </div>
      </div>
    </div>

    <div class="flex-grow min-h-0 min-w-0 pb-2 px-2 relative" id='calendar'>
      <div #myDatePicker *ngIf="isOpenCalendar" class="datePickerCustomButton">
        <app-calendar-picker
          (dateSelected)="clickDateSelected($event)"
          (changeDate)="ChangeDate($event)"
          [dateFullCalendar]="this.dateDefault"
          id="calendarPicker"></app-calendar-picker>
      </div>

      <div class="calendar-loading-overlay" *ngIf="loadingEvents" role="status" aria-live="polite">
        <div class="calendar-loading-box">
          <span class="calendar-loading-spinner"></span>
          <span class="calendar-loading-text">Cargando eventos…</span>
        </div>
      </div>
    </div>
  </div>

  <div #modal></div>
  <div #modalAssociate></div>
  <div #messages></div>
  <div #series></div>
  <div #options></div>

  <nav *ngIf="mostrar" #myDOMElement
       class="ctx-menu"
       [ngStyle]="{'left':getPositionX(),'top':getPositionY(),'position':'absolute'}">
    <ul class="ctx-menu-list">
      <li class="ctx-menu-item" [class.ctx-open]="openSubmenu==='move'"
          (mouseenter)="openSubmenuWithDelay('move')" (mouseleave)="closeSubmenuWithDelay()">
        <div class="ctx-menu-row">
          <lucide-icon name="folder-input" [size]="18"></lucide-icon>
          <a>Mover a</a>
        </div>
        <ul [ngClass]="{'fixedX': minOffSetX, 'noFixedX': !minOffSetX, 'fixedY': minOffSetY, 'noFixedY': !minOffSetY}">
          <div class="ctx-submenu">
            <label>Mover a</label>
            <app-date-picker (dateSelected)="updateDateEvent($event)"></app-date-picker>
          </div>
        </ul>
      </li>
      <li class="ctx-menu-item" [class.ctx-open]="openSubmenu==='copy'"
          (mouseenter)="openSubmenuWithDelay('copy')" (mouseleave)="closeSubmenuWithDelay()">
        <div class="ctx-menu-row">
          <lucide-icon name="copy" [size]="18"></lucide-icon>
          <a>Copiar a</a>
        </div>
        <ul [ngClass]="{'fixedX': minOffSetX, 'noFixedX': !minOffSetX, 'fixedY': minOffSetY, 'noFixedY': !minOffSetY}">
          <div class="ctx-submenu">
            <label>Copiar a</label>
            <app-date-picker (dateSelected)="copyEvent($event)"></app-date-picker>
          </div>
        </ul>
      </li>
      <li class="ctx-menu-item">
        <div class="ctx-menu-row danger" (click)="deleteEvent($event)">
          <lucide-icon name="trash-2" [size]="18"></lucide-icon>
          <a>Eliminar</a>
        </div>
      </li>
      <li class="ctx-menu-item" *ngIf="isAppointmentForArrival()">
        <div class="ctx-menu-row" (click)="toggleArrived()">
          <lucide-icon [name]="argsObject[0]?.arrived ? 'wrench' : 'car'" [size]="18"></lucide-icon>
          <a>{{argsObject[0]?.arrived ? 'Desmarcar llegada' : 'Marcar llegada'}}</a>
        </div>
      </li>
    </ul>
  </nav>

  <div class="toast-notification" *ngIf="showToast" role="status" aria-live="polite">
    <div class="toast-icon">
      <lucide-icon name="check" [size]="18"></lucide-icon>
    </div>
    <div class="toast-body" [innerHTML]="toastTitle"></div>
    <div class="toast-actions">
      <button type="button" *ngIf="toastUndo" class="toast-btn undo" (click)="toastUndoAction()">Deshacer</button>
      <button type="button" class="toast-btn close" (click)="closeToast()">Cerrar</button>
    </div>
  </div>

  <app-day-detail-modal *ngIf="showDayDetail"
                        [title]="dayDetailTitle"
                        [events]="dayDetailEvents"
                        (closeMeEvent)="closeDayDetail()"
                        (selectEvent)="openDayDetailEvent($event)">
  </app-day-detail-modal>
</div>